import React from 'react'
import { Link } from 'react-router-dom';
import { getImageUrl, formatRating } from '../../services/api';

function DestinationCard(props) {
    const { 
        destinationID, 
        destinationSlug,
        destinationImage, 
        destinationTitle, 
        destinationPrice,
        destinationCountry,
        destinationCity,
        destinationRating,
        destinationReviewCount,
        destinationDuration,
        destinationDifficulty,
        destinationDescription,
        destinationFeatured
    } = props;
    return (
        <>
            <div className={`tour-box th-ani ${destinationFeatured ? 'featured-item' : ''}`}>
                {destinationFeatured && (
                    <div className="featured-badge">
                        <span className="badge bg-primary">Featured</span>
                    </div>
                )}
                <div className="tour-box_img global-img">
                    <img 
                        src={getImageUrl(destinationImage) || '/assets/img/tour/tour_box_1.jpg'} 
                        alt={destinationTitle || 'Destination'}
                        onError={(e) => {
                            e.target.src = '/assets/img/tour/tour_box_1.jpg';
                        }}
                    />
                </div>
                <div className="tour-content">
                    <div className="tour-meta">
                        <span className="location">
                            <i className="fa-light fa-location-dot" />
                            {destinationCity}, {destinationCountry}
                        </span>
                        <span className={`difficulty-badge ${destinationDifficulty}`}>
                            {destinationDifficulty}
                        </span>
                    </div>
                    <h3 className="box-title">
                        <Link to={`/destination/${destinationSlug || destinationID}`}>
                            {destinationTitle || 'Destination'}
                        </Link>
                    </h3>
                    {destinationDescription && (
                        <p className="tour-description">{destinationDescription}</p>
                    )}
                    <div className="tour-rating">
                        <div
                            className="star-rating"
                            role="img"
                            aria-label={`Rated ${formatRating(destinationRating)} out of 5`}
                        >
                            <span style={{ width: `${(destinationRating / 5) * 100}%` }}>
                                Rated
                                <strong className="rating">{formatRating(destinationRating)}</strong> out of 5
                                based on <span className="rating">{destinationReviewCount}</span> reviews
                            </span>
                        </div>
                        <Link
                            to={`/destination/${destinationSlug || destinationID}`}
                            className="woocommerce-review-link"
                        >
                            (<span className="count">{destinationReviewCount}</span> Reviews)
                        </Link>
                    </div>
                    <h4 className="tour-box_price">
                        <span className="currency">{destinationPrice || '$0.00'}</span>/Person
                    </h4>
                    <div className="tour-action">
                        <span>
                            <i className="fa-light fa-clock" />{destinationDuration} Days
                        </span>
                        <Link to="/contact" className="th-btn style4 th-icon">
                            Book Now
                        </Link>
                    </div>
                </div>
            </div>
        </>
    )
}

export default DestinationCard
